<template>
  <div data-test="course-search-bar" class="course-search-bar body--p1--medium">
    <div class="course-search-bar__items">
      <!--
      <div
        class="course-search-bar__input-box course-search-bar__input-box--width"
      >
        <div class="course-search-bar__input-box-border"></div>
        <USInputCalendar
          v-model="calendarValue"
          :min-date="new Date()"
          class="course-search-bar__input-item course-search-bar__input-calender"
        >
          <template #heading>
            <p class="display--d2--semibold course-search-bar__input-heading">
              Date
            </p>
          </template>
        </USInputCalendar>
      </div>
      -->
      <div
        class="course-search-bar__input-box course-search-bar__input-box--width"
      >
        <div class="course-search-bar__input-box-border"></div>
        <Suspense>
          <USInputGoogleGeolocation
            v-model:updateCoordinates="coordinatesProp"
            :api-key="apiKey"
            class="course-search-bar__input-item"
            :loc="loc"
            heading="Location"
            @coordinates="updateCoordinates"
          />
        </Suspense>
      </div>
      <div
        class="course-search-bar__input-box course-search-bar__input-box--width"
      >
        <div class="course-search-bar__input-box-border"></div>
        <Suspense>
          <USInputSelect
            v-model="amenitiesValue"
            class="course-search-bar__advanced-input"
            :options="amenitiesTypeSelect"
            :select-diameter="22"
            :multiselect="true"
            direction="bottom"
          >
            <template #heading>
              <p class="display--d2--semibold course-search-bar__input-heading">
                Amenities
              </p>
            </template>
          </USInputSelect>
        </Suspense>
      </div>
      <!--
      <div
        class="course-search-bar__input-box course-search-bar__input-box--width"
      >
        <USInputNumber
          v-model="playersValue"
          icon="users"
          :icon-diameter="30"
          class="course-search-bar__input-item course-search-bar__input-players"
          :max="4"
        >
          <template #heading>
            <p class="display--d2--semibold course-search-bar__input-heading">
              Players
            </p>
          </template>
        </USInputNumber>
      </div>
      -->
    </div>
    <div class="course-search-bar__lower-items">
      <div class="course-search-bar__button-wrapper">
        <USButton
          :label="buttonLabel"
          class="course-search-bar__button"
          @click="
            $emit('submitCourseSearch', {
              startDate: calendarValue.start
                ? calendarValue.start.toISOString()
                : null,
              endDate: calendarValue.end
                ? calendarValue.end.toISOString()
                : null,
              holes: holeValue || null,
              players: playersValue || null,
              lat: coordinatesProp ? coordinatesProp.lat : null,
              lon: coordinatesProp ? coordinatesProp.lon : null,
              loc: coordinatesProp ? coordinatesProp.loc : null,
              clubs: golfClubsValue || null,
              amenitiesValue: amenitiesValue || null,
              price: priceValue || null
            })
          "
        />
      </div>
    </div>
  </div>
  <div ref="advancedToggle" class="course-search-bar__advanced-toggle">
    <USIcon
      class="course-search-bar__icon"
      :class="showAdvancedRef ? 'course-search-bar__icon--rotate' : ''"
      name="plus"
      css-diameter="var(--iconDiameter)"
    />
    <USButton
      is="button"
      :label="`Advanced Filters ${
        appliedFilters > 0 ? '(' + appliedFilters + ')' : ''
      }`"
      type="inline"
      @click="toggleAdvancedFilters()"
    />
  </div>
  <div ref="advancedSearch" class="course-search-bar__advanced">
    <div class="course-search-bar__advanced-inputs">
      <div class="course-search-bar__advanced-input-box">
        <USInputSelect
          v-model="holeValue"
          class="course-search-bar__advanced-input"
          :options="holeTypeSelect"
          :select-diameter="22"
          direction="bottom"
        >
          <template #heading>
            <p class="display--d2--semibold course-search-bar__input-heading">
              Holes
            </p>
          </template>
        </USInputSelect>
      </div>
      <!--
      <div class="course-search-bar__advanced-input-box">
        <ClientOnly>
          <USInputSelect
            v-model="amenitiesValue"
            class="course-search-bar__advanced-input"
            :options="amenitiesTypeSelect"
            :select-diameter="22"
            :multiselect="true"
            direction="bottom"
          >
            <template #heading>
              <p class="display--d2--semibold course-search-bar__input-heading">
                Amenities
              </p>
            </template>
          </USInputSelect>
        </ClientOnly>
      </div>
      -->
      <!--
      <div class="course-search-bar__advanced-input-box">
        
        <ClientOnly>
          <USInputSelect
            v-model="golfClubsValue"
            class="course-search-bar__advanced-input"
            :options="golfClubSelect"
            :select-diameter="22"
            :multiselect="true"
            direction="bottom"
          >
            <template #heading>
              <p class="display--d2--semibold course-search-bar__input-heading">
                Golf Clubs
              </p>
            </template>
          </USInputSelect>
        </ClientOnly>        
      </div>
    -->
      <div class="course-search-bar__advanced-input-box">
        <ClientOnly>
          <USInputSelect
            v-model="priceValue"
            class="course-search-bar__advanced-input"
            :options="priceTypeSelect"
            :multiselect="true"
            :select-diameter="22"
            direction="bottom"
          >
            <template #heading>
              <p class="display--d2--semibold course-search-bar__input-heading">
                Price
              </p>
            </template>
          </USInputSelect>
        </ClientOnly>
      </div>
      <div class="course-search-bar__advanced-buttons">
        <div class="course-search-bar__advanced-buttons--left">
          <USButton
            is="button"
            label="Apply filters"
            type="inline"
            @click="
              $emit('submitCourseSearch', {
                startDate: calendarValue.start
                  ? calendarValue.start.toISOString()
                  : null,
                endDate: calendarValue.end
                  ? calendarValue.end.toISOString()
                  : null,
                holes: holeValue || null,
                players: playersValue || null,
                lat: coordinatesProp ? coordinatesProp.lat : null,
                lon: coordinatesProp ? coordinatesProp.lon : null,
                loc: coordinatesProp ? coordinatesProp.loc : null,
                clubs: golfClubsValue || null,
                amenitiesValue: amenitiesValue || null,
                price: priceValue || null
              })
            "
          />
        </div>
        <div class="course-search-bar__advanced-buttons--right">
          <USButton
            is="button"
            label="Clear all"
            type="inline"
            @click="clearFilters()"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType, ref, watch } from 'vue'
import USInputCalendar from '@base/components/USInputCalendar/USInputCalendar.vue'
import USInputGoogleGeolocation from '@base/components/USInputGoogleGeolocation/USInputGoogleGeolocation.vue'
import USInputSelect from '@base/components/USInputSelect/USInputSelect.vue'
import USButton from '@base/components/USButton/USButton.vue'
import ClientOnly from '@base/components/ClientOnly/ClientOnly.vue'
import USInputNumber from '@base/components/USInputNumber/USInputNumber.vue'
import USIcon from '@base/components/USIcon/USIcon.vue'

interface option {
  label: string
  value: string
}

export default defineComponent({
  name: 'CourseSearchBar',
  components: {
    USInputCalendar,
    USInputGoogleGeolocation,
    USInputSelect,
    USInputNumber,
    USButton,
    ClientOnly,
    USIcon
  },
  props: {
    apiKey: {
      type: String,
      default: ''
    },
    holeTypeSelect: {
      type: Array as PropType<option[]>,
      default: () => [
        { label: '9', value: 9 },
        { label: '18', value: 18 }
      ]
    },
    amenitiesTypeSelect: {
      type: Array as PropType<option[]>,
      default: () => []
    },
    golfClubSelect: {
      type: Array as PropType<option[]>,
      default: () => []
    },
    priceTypeSelect: {
      type: Array as PropType<option[]>,
      default: () => [
        { label: '$', value: 'RANGE_1' },
        { label: '$ $', value: 'RANGE_2' },
        { label: '$ $ $', value: 'RANGE_3' },
        { label: '$ $ $ $', value: 'RANGE_4' }
      ]
    },
    buttonLabel: {
      type: String,
      default: ''
    },
    holes: {
      type: Number,
      default: undefined
    },
    players: {
      type: Number,
      default: 0
    },
    course: {
      type: String,
      default: ''
    },
    startDate: {
      type: Date,
      default: () => undefined
    },
    endDate: {
      type: Date,
      default: () => undefined
    },
    lat: {
      type: Number,
      default: () => undefined
    },
    lon: {
      type: Number,
      default: () => undefined
    },
    loc: {
      type: String,
      default: () => undefined
    },
    showAdvanced: {
      type: Boolean,
      default: true
    },
    price: {
      type: Array as PropType<string[]>,
      default: () => undefined
    },
    clubs: {
      type: Array as PropType<string[]>,
      default: () => undefined
    },
    amenities: {
      type: Array as PropType<string[]>,
      default: () => undefined
    }
  },
  emits: ['submitCourseSearch'],

  setup(props, { emit }) {
    const showAdvancedRef = ref<boolean>(props.showAdvanced)
    const calendarValue = ref(
      props.startDate && props.endDate
        ? {
            start: new Date(props.startDate),
            end: new Date(props.endDate)
          }
        : {}
    )

    const holeSelect = ref()
    const playersValue = ref(props.players || 0)
    const courseValue = ref()
    const holeValue = ref([props.holes ? props.holes.toString() : ''])
    const amenitiesValue = ref(props.amenities)
    const golfClubsValue = ref(props.clubs)
    const priceValue = ref(props.price)

    const advancedSearch = ref<HTMLElement>()
    const advancedToggle = ref<HTMLElement>()
    const appliedFilters = ref<number>(0)
    const dateFilled = ref<number>(0)
    const locationFilled = ref<number>(0)
    const playersFilled = ref<number>(0)
    const holesFilled = ref<number>(0)
    const amenitiesFilled = ref<number>(0)
    const clubsFilled = ref<number>(0)
    const priceFilled = ref<number>(0)

    const coordinatesProp = ref<{
      lat: number
      lon: number
      loc: string
    } | null>(null)
    if (props.lat !== undefined && props.lon !== undefined && props.loc)
      coordinatesProp.value = {
        lat: props.lat,
        lon: props.lon,
        loc: props.loc
      }

    if (calendarValue.value.start || calendarValue.value.end) {
      dateFilled.value = 1
    }

    if (props.lat || props.loc || props.lon) {
      locationFilled.value = 1
    }

    if (props.players) {
      playersFilled.value = 1
    }

    if (holeValue.value[0].length) {
      holesFilled.value = 1
    }

    if (amenitiesValue.value?.length) {
      amenitiesFilled.value = 1
    }

    if (golfClubsValue.value?.length) {
      clubsFilled.value = 1
    }

    if (priceValue.value?.length) {
      priceFilled.value = 1
    }

    const updateAppliedFilter = () => {
      appliedFilters.value =
        dateFilled.value +
        locationFilled.value +
        playersFilled.value +
        holesFilled.value +
        amenitiesFilled.value +
        clubsFilled.value +
        priceFilled.value
    }

    updateAppliedFilter()

    const updateCoordinates = (value: {
      lat: number
      lon: number
      loc: string
    }) => {
      coordinatesProp.value = value
    }

    const clearFilters = () => {
      playersValue.value = 0
      holeValue.value = []
      amenitiesValue.value = []
      golfClubsValue.value = []
      priceValue.value = []
      calendarValue.value

      appliedFilters.value = 0
      dateFilled.value = 0
      locationFilled.value = 0
      playersFilled.value = 0
      holesFilled.value = 0
      amenitiesFilled.value = 0
      clubsFilled.value = 0
      priceFilled.value = 0

      emit('submitCourseSearch', {
        startDate: null,
        endDate: null,
        holes: [],
        players: null,
        lat: null,
        lon: null,
        loc: null,
        clubs: [],
        amenitiesValue: [],
        price: []
      })
    }

    const toggleAdvancedFilters = () => {
      showAdvancedRef.value = !showAdvancedRef.value
      if (advancedSearch.value) {
        if (
          advancedSearch.value.classList.contains(
            'course-search-bar__advanced--active'
          )
        ) {
          advancedSearch.value.classList.remove(
            'course-search-bar__advanced--active'
          )

          if (advancedToggle.value) {
            advancedToggle.value.classList.remove(
              'course-search-bar__advanced-toggle--hide'
            )
          }
        } else {
          advancedSearch.value.classList.add(
            'course-search-bar__advanced--active'
          )
          if (
            advancedToggle.value &&
            advancedToggle.value.classList.contains(
              'course-search-bar__advanced-toggle'
            )
          ) {
            advancedToggle.value.classList.add(
              'course-search-bar__advanced-toggle--hide'
            )
          }
        }
      }
    }

    watch(
      () => calendarValue.value,
      (newValue) => {
        if (newValue.start || newValue.end) {
          dateFilled.value = 1
        } else {
          dateFilled.value = 0
        }
        updateAppliedFilter()
      }
    )

    watch(
      () => coordinatesProp.value,
      (newValue) => {
        if (newValue?.lat || newValue?.lon || newValue?.loc) {
          locationFilled.value = 1
        } else {
          locationFilled.value = 0
        }
        updateAppliedFilter()
      }
    )

    watch(
      () => playersValue.value,
      (newValue) => {
        if (newValue) {
          playersFilled.value = 1
        } else {
          playersFilled.value = 0
        }
        updateAppliedFilter()
      }
    )

    watch(
      () => holeValue.value,
      (newValue) => {
        if (newValue.length) {
          holesFilled.value = 1
        } else {
          holesFilled.value = 0
        }
        updateAppliedFilter()
      }
    )

    watch(
      () => amenitiesValue.value,
      (newValue) => {
        if (newValue?.length) {
          amenitiesFilled.value = 1
        } else {
          amenitiesFilled.value = 0
        }
        updateAppliedFilter()
      }
    )

    watch(
      () => golfClubsValue.value,
      (newValue) => {
        if (newValue?.length) {
          clubsFilled.value = 1
        } else {
          clubsFilled.value = 0
        }
        updateAppliedFilter()
      }
    )

    watch(
      () => priceValue.value,
      (newValue) => {
        if (newValue?.length) {
          priceFilled.value = 1
        } else {
          priceFilled.value = 0
        }
        updateAppliedFilter()
      }
    )

    return {
      calendarValue,
      holeSelect,
      playersValue,
      holeValue,
      amenitiesValue,
      golfClubsValue,
      priceValue,
      updateCoordinates,
      coordinatesProp,
      courseValue,
      toggleAdvancedFilters,
      advancedSearch,
      advancedToggle,
      clearFilters,
      showAdvancedRef,
      appliedFilters
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@base/styles/v1.0/scss/foundations/breakpoint';
@use '@base/styles/v1.0/scss/foundations/motion';

.course-search-bar {
  align-items: center;
  background: var(--color--neutral-a5);
  border-radius: var(--border-radius--large);
  box-shadow: var(--box-shadow--b1);
  display: flex;
  flex-flow: column;
  padding: var(--spacing--6);

  @include breakpoint.min-width(breakpoint.$breakpoint--desktop) {
    flex-flow: row nowrap;
  }

  &__items {
    color: var(--color--primary-b2);
    display: flex;
    flex-flow: column;
    width: calc(100% - var(--spacing--6));

    @include breakpoint.min-width(breakpoint.$breakpoint--tablet) {
      flex-flow: row nowrap;
    }
  }

  &__input-heading {
    color: var(--color--neutral-a1) !important;
    font-weight: var(--font-weight--medium) !important;
    margin-bottom: var(--spacing--8);
  }

  &__input-calender {
    &:hover {
      :deep(.us-input-border) {
        box-shadow: none;
      }
    }
  }

  &__input-players {
    &:hover {
      :deep(.number-input-wrapper) {
        padding: var(--spacing--8) 0;
        padding-right: var(--spacing--4);
      }
    }
  }

  &__input-box {
    margin-bottom: var(--spacing--7);

    &--width {
      width: 100%;
    }
  }

  &__input-box-border {
    border-right: var(--line-weight--light) solid var(--color--neutral-a4);
    bottom: 0;
    display: none;
    height: 100%;
    position: absolute;
    right: calc(0px + var(--spacing--8));
    width: var(--spacing--8);
    z-index: 2;

    @include breakpoint.min-width(breakpoint.$breakpoint--tablet) {
      display: inline-block;
    }
  }

  &__lower-items {
    padding-top: var(--spacing--6);

    @include breakpoint.min-width(breakpoint.$breakpoint--desktop) {
      padding-left: var(--spacing--5);
      padding-top: 0;
    }
  }

  &__advanced {
    align-items: center;
    display: flex;
    flex-flow: column;
    max-height: 0;
    opacity: 0;
    padding: var(--spacing--6) 0;

    &--active {
      opacity: 1;
      max-height: 100%;
    }
  }

  &__advanced-toggle {
    color: var(--color--primary-b1);
    display: flex;
    flex-direction: row;
    justify-content: center;
    overflow: hidden;
    margin-top: var(--spacing--6);
    max-height: 100%;
  }

  &__icon {
    margin-right: var(--spacing--8);
    transform: rotate(0deg);
    transition: transform motion.duration(3) ease-in;
    will-change: transform;

    &--rotate {
      transform: rotate(45deg);
    }
  }

  &__advanced-inputs {
    display: flex;
    flex-flow: column;
    width: 100%;

    @include breakpoint.min-width(breakpoint.$breakpoint--desktop) {
      flex-flow: row wrap;
      justify-content: space-between;
    }
  }

  &__advanced-input-box {
    &:not(:first-child) {
      margin-top: var(--spacing--6);
    }

    @include breakpoint.min-width(breakpoint.$breakpoint--desktop) {
      flex-basis: 50%;
      margin-top: var(--spacing--6);
      max-width: calc(50% - var(--spacing--6));
      width: calc(50% - var(--spacing--6));
    }
  }

  &__advanced-buttons {
    display: flex;
    flex-basis: 100%;
    flex-flow: row nowrap;
    justify-content: center;
    margin-top: var(--spacing--5);

    &--left {
      margin-right: var(--spacing--6);
    }

    &--right {
      margin-left: var(--spacing--6);
    }
  }
}

:deep(.us-input) {
  color: var(--color--neutral-a1) !important;
  font-weight: var(--font-weight--medium) !important;
}

:deep(.input-heading-wrapper) {
  color: var(--color--neutral-a1) !important;
  font-weight: var(--font-weight--medium) !important;
  margin-bottom: 0 !important;
}

:deep(.input-wrapper--placeholder) {
  color: var(--color--primary-b3) !important;
  font-weight: var(--font-weight--regular) !important;
}

//Calender
:deep(.us-input-border) {
  border: none !important;
  border-radius: 0 !important;
  color: var(--color--primary-b3) !important;
  padding: var(--spacing--8) 0 !important;
  padding-right: var(--spacing--4) !important;

  @include breakpoint.min-width(breakpoint.$breakpoint--tablet) {
    padding-right: var(--spacing--5) !important;
  }
}

:deep(.us-input--calendar) {
  z-index: 1;
}

:deep(.us-icon--calendar) {
  right: var(--spacing--8) !important;

  @include breakpoint.min-width(breakpoint.$breakpoint--tablet) {
    right: var(--spacing--6) !important;
  }
}

:deep(.vc-popover-content-wrapper) {
  right: 0 !important;
  left: 0 !important;

  @include breakpoint.min-width(breakpoint.$breakpoint--tablet) {
    right: -4% !important;
    left: auto !important;
  }
}

//Geo
:deep(.us-input-google-geo__input) {
  color: var(--color--primary-b3) !important;
  font-weight: var(--font-weight--regular) !important;
  padding: var(--spacing--8) 0 !important;
  padding-right: var(--spacing--5) !important;
}

:deep(.us-input-google-geo__input::placeholder) {
  color: var(--color--primary-b3) !important;
}

:deep(.us-input-google-geo__current-loc-button-wrapper) {
  @include breakpoint.min-width(breakpoint.$breakpoint--tablet) {
    right: var(--spacing--6) !important;
  }
}

//Players
:deep(.number-input-wrapper) {
  border: none !important;
  border-radius: 0 !important;
  padding: var(--spacing--8) 0 !important;
  padding-right: var(--spacing--4) !important;

  &:hover {
    border: none !important;
  }
}

:deep(.number-manual-input) {
  color: var(--color--primary-b3) !important;
  font-weight: var(--font-weight--regular) !important;
}

:deep(.number-input-icon) {
  right: 0 !important;

  @include breakpoint.min-width(breakpoint.$breakpoint--tablet) {
    right: var(--spacing--8) !important;
  }
}

//Amenities
:deep(.us-input-select) {
  border: none !important;
  color: var(--color--primary-b3) !important;
  font-weight: var(--font-weight--regular) !important;
  padding: var(--spacing--8) 0 !important;

  .select__selected {
    padding: 0;
  }

  .select__close-icon, .select__open-icon {
    right: var(--spacing--9) !important;
    @include breakpoint.min-width(breakpoint.$breakpoint--tablet) {
      right: var(--spacing--6) !important;
    }
  }
}
</style>
